import {
	Grid2,
	Paper,
	styled,
	Table,
	TableBody,
	TableCell,
	tableCellClasses,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
	Typography,
} from '@mui/material';
import { useMainCustomStyle } from '../../assets/theme/Theme';
import SuperAdminSideNavigationBar from '../../components/SuperAdminSideNavigationBar';
import { getAccessToken } from '../../Utils/AuthUtil';
import { Stats } from '../../types';
import { useEffect, useState } from 'react';
import { fetchStatsForDashboard } from '../../services/UserService';

function StatsDashboard() {
	const mainDivStyle = useMainCustomStyle();
	const token = getAccessToken();
	const [userData, setUserData] = useState<Array<Stats>>([]);
	const [guestCount, setGuestCount] = useState(0);
	const [systemUserCount, setSystemUserCount] = useState(0);

	const [rowsPerPage, setRowsPerPage] = useState(15);
	const [page, setPage] = useState(0);

	useEffect(() => {
		getAllStats();
	}, []);

	async function getAllStats() {
		const data = await fetchStatsForDashboard(token ? token : '');
		setUserData(data?.tableData.reverse());
		setSystemUserCount(data ? data?.loginUserStatCount : 0);
		setGuestCount(data ? data?.guestStatCount : 0);
	}

	const handleChangePage = (
		event: React.MouseEvent<HTMLButtonElement> | null,
		newPage: number,
	) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	return (
		<>
			<SuperAdminSideNavigationBar />
			<div style={mainDivStyle}>
				<Grid2 container paddingLeft={'20px'} paddingRight={'20px'}>
					<Grid2 component={'div'} paddingLeft="30px">
						<Typography
							variant="h6"
							fontWeight={'600'}
							color="#21C17A">
							Usage Stats
						</Typography>
					</Grid2>
					<Grid2
						container
						sx={{
							marginTop: '10px',
							padding: '10px',
							width: '100%',
							paddingLeft: '30px',
						}}>
						<Grid2
							sx={{
								backgroundColor: '#FFFFFF',
								borderRadius: '6px',
								flexDirection: 'column',
								display: 'flex',
								paddingX: '24px',
								paddingY: '12px',
								border: '0.6px solid #F1F3FA',
							}}>
							<Typography
								color={'#5E5C5C'}
								fontSize={'14px'}
								paddingBottom={'5px'}
								fontWeight={'400'}>
								{'LoggedIn Users'}
							</Typography>
							<Typography
								color={'#324054'}
								fontSize={'18px'}
								paddingY={'2.5px'}
								fontWeight={'600'}>
								{systemUserCount}
							</Typography>
						</Grid2>
						<Grid2
							sx={{
								backgroundColor: '#FFFFFF',
								borderRadius: '6px',
								flexDirection: 'column',
								display: 'flex',
								paddingX: '24px',
								paddingY: '12px',
								border: '0.6px solid #F1F3FA',
								marginLeft: { md: '15px', xs: '0px' },
								marginTop: { md: '0px', xs: '5px' },
							}}>
							<Typography
								color={'#5E5C5C'}
								fontSize={'14px'}
								paddingBottom={'5px'}
								fontWeight={'400'}>
								{'Guest Users'}
							</Typography>
							<Typography
								color={'#324054'}
								fontSize={'18px'}
								paddingY={'2.5px'}
								fontWeight={'600'}>
								{guestCount}
							</Typography>
						</Grid2>
					</Grid2>
					<Grid2 container width={'100%'} paddingLeft="30px">
						<TableContainer
							component={Paper}
							style={{ boxShadow: 'none', marginTop: '30px' }}>
							<Table
								sx={{ minWidth: 700 }}
								aria-label="customized table">
								<TableHead>
									<TableRow>
										<StyledTableCell align="center">
											<TableHeaderText>
												Email/Visitor ID
											</TableHeaderText>
										</StyledTableCell>
										<StyledTableCell align="center">
											<TableHeaderText>
												Clicked Location
											</TableHeaderText>
										</StyledTableCell>
										<StyledTableCell align="center">
											<TableHeaderText>
												Clicked Element
											</TableHeaderText>
										</StyledTableCell>
										<StyledTableCell align="center">
											<TableHeaderText>
												User Type
											</TableHeaderText>
										</StyledTableCell>
										<StyledTableCell align="center">
											<TableHeaderText>
												Created on
											</TableHeaderText>
										</StyledTableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{userData && userData.length > 0 ? (
										userData
											.slice(
												page * rowsPerPage,
												page * rowsPerPage +
													rowsPerPage,
											)
											.map((stat, index) => {
												return (
													<StyledTableRow key={index}>
														<StyledTableCell align="center">
															<TableRowText>
																{stat.email}
															</TableRowText>
														</StyledTableCell>
														<StyledTableCell align="center">
															<TableRowText>
																{
																	stat.clickedLocation
																}
															</TableRowText>
														</StyledTableCell>
														<StyledTableCell align="center">
															<TableRowText>
																{
																	stat.clickedItem
																}
															</TableRowText>
														</StyledTableCell>
														<StyledTableCell align="center">
															<TableRowText>
																{stat.userLoggedIn
																	? 'LoggedIn user'
																	: 'Guest'}
															</TableRowText>
														</StyledTableCell>
														<StyledTableCell align="center">
															<TableRowText>
																{new Date(
																	stat.createdDate,
																)
																	.getDate()
																	.toString()
																	.padStart(
																		2,
																		'0',
																	) +
																	'/' +
																	(
																		new Date(
																			stat.createdDate,
																		).getMonth() +
																		1
																	)
																		.toString()
																		.padStart(
																			2,
																			'0',
																		) +
																	'/' +
																	new Date(
																		stat.createdDate,
																	)
																		.getFullYear()
																		.toString()}
															</TableRowText>
														</StyledTableCell>
													</StyledTableRow>
												);
											})
									) : (
										<StyledTableRow>
											<StyledTableCell
												colSpan={6}
												align="center">
												<TableRowText>
													No data available
												</TableRowText>
											</StyledTableCell>
										</StyledTableRow>
									)}
								</TableBody>
							</Table>
						</TableContainer>
						<TablePagination
							rowsPerPageOptions={[]}
							component="div"
							count={userData && userData.length}
							rowsPerPage={rowsPerPage}
							page={page}
							onPageChange={handleChangePage}
							onRowsPerPageChange={handleChangeRowsPerPage}
						/>
					</Grid2>
				</Grid2>
			</div>
		</>
	);
}

const StyledTableCell = styled(TableCell)(() => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: '#FFFFFF',
		color: 'rgba(0, 0, 0, 0.5)',
		paddingTop: '20px',
		fontSize: 12,
		fontWeight: 600,
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 12,
		fontWeight: 400,
		color: '#000000',
	},
}));

const StyledTableRow = styled(TableRow)(() => ({
	'&:nth-of-type(odd)': {
		background:
			'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #C2C9D1',
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0,
	},
}));

const TableHeaderText = styled(Typography)(() => ({
	fontSize: '12px',
	fontWeight: '600',
	color: 'rgba(0, 0, 0, 0.5)',
}));

const TableRowText = styled(Typography)(() => ({
	fontSize: '12px',
	fontWeight: '400',
	color: 'rgba(0, 0, 0, 1)',
}));

export default StatsDashboard;
